import React from 'react';
import './GameButton.css'

type GameButtonProps = {
    title: string
    position: number
    isActive: boolean
    setActiveGame: React.Dispatch<React.SetStateAction<number>>
}

function GameButton ({title, position,isActive, setActiveGame}: GameButtonProps){  
  return (
  <>
    <span className={isActive ? 'activeLink' : 'inactiveLink'}
        onClick={() => {
        setActiveGame(position)
    }}>{title}</span>
  </>
  )
}

export default GameButton